import { Suspense, lazy, useState } from 'react';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { Button } from 'components/FormComponents';
import { IconButton } from 'components/IconButton/IconButton';

export const RenewalResultsModal = ({
  result,
  visible,
  onStatusChange = () => {},
  onClose = () => {},
}) => {
  const PDFPreview = lazy(() => import('components/FilePreview/PDFPreview'));

  const [loading, setLoading] = useState(true);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
    setLoading(false);
  };

  const handleStatusChange = status => {
    onStatusChange(result?.candidate_check_id, status);
  };

  const open = e => {
    e.preventDefault();
    e.stopPropagation();
    window.open(result.upload_url, '_blank');
  };

  const nextPage = () => {
    setLoading(true);
    setPageNumber(page => Math.min(page + 1, numPages));
  };

  const prevPage = () => {
    setLoading(true);
    setPageNumber(page => Math.max(page - 1, 1));
  };

  return (
    <AnimatedModal visible={visible} onClose={onClose} title={result?.candidate_name}>
      {result?.upload_url && (
        <>
          <div className="position-relative u-card u-padding background-secondary card-with-border u-border-radius">
            <Suspense fallback={<div>Loading PDF viewer...</div>}>
              <PDFPreview
                url={result.upload_url}
                onLoadSuccess={onLoadSuccess}
                pageNumber={pageNumber}
                setIsLoading={setLoading}
                onClick={open}
              />
            </Suspense>
            <div className="u-divider" />
            <div className="d-flex justify-content-between">
              <IconButton
                className="u-margin-right--small"
                icon="arrow-left"
                onClick={e => {
                  e.stopPropagation();
                  prevPage();
                }}
                disabled={pageNumber <= 1}
              />
              <IconButton
                // className={styles.toggleButton}
                icon="arrow-right"
                onClick={e => {
                  e.stopPropagation();
                  nextPage();
                }}
                disabled={pageNumber >= numPages}
              />
            </div>
          </div>
          <div className="d-flex justify-content-between u-margin-top">
            <Button onClick={onClose} type="secondary" small>
              Cancel
            </Button>
            <div className="d-flex">
              <Button
                onClick={() => handleStatusChange('not_approved')}
                className="u-margin-right--small"
                type="delete"
                small>
                Reject
              </Button>
              <Button onClick={() => handleStatusChange('approved')} type="success" small>
                Approved
              </Button>
            </div>
          </div>
        </>
      )}
    </AnimatedModal>
  );
};
